import React from "react";
import PropTypes from 'prop-types';
import { Separator } from "../Headers/Separator";
import { CardItem } from "./CardItem";

export const CardSection = ({ title, items, renderItem }) => {
    if (!items || items.length < 1) {
        return null;
    }

    return (
        <section className="section">
            <div className="container">
                <Separator name={title} />
                <div className="row row-gap-3">
                    {items.map((item, i) => {
                        if (renderItem) {
                            return <React.Fragment key={i}>{renderItem(item, i)}</React.Fragment>;
                        }
                        // Default rendering: expects { name, url_image or url, type or text }
                        return (
                            <CardItem
                                key={i}
                                name={item.name}
                                url={item.url_image || item.url}
                                text={item.type || item.text}
                                imageAlt={item.name || "Item"}
                            />
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

CardSection.propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.array,
    renderItem: PropTypes.func,
};

